import React from 'react';
const LinkContext = React.createContext();

export default LinkContext;